import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { AdvAnnouncement } from "@onsip/common/services/api/resources/announcement/adv-announcement";
import { Recording } from "@onsip/common/services/api/resources/recording/recording";
import { RecordingService } from "@onsip/common/services/api/resources/recording/recording.service";
import { Subscription } from "rxjs";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Component({
  selector: "onsip-adv-announcements-recording-view",
  templateUrl: "./adv-announcements-recording-view.component.html",
  styleUrls: ["./adv-announcements-recording-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdvAnnouncementsRecordingViewComponent implements OnInit, OnDestroy {
  @Input() announcement!: AdvAnnouncement;
  @Input() recording!: Recording | undefined;
  @Output() editPanel = new EventEmitter<void>();
  isMobile = false;

  audioFile: string | undefined = "";

  private unsubscriber = new Subscription();

  constructor(
    private recordingService: RecordingService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {
    if (this.recording) {
      const audioUrl = this.getRecordingPath();
      this.audioFile = audioUrl;
    }

    this.unsubscriber.add(
      this.breakpointObserver.observe(Breakpoints.XSmall).subscribe(result => {
        this.isMobile = result.matches;
      })
    );
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  getRecordingPath(): string {
    if (this.recording) {
      return this.recordingService.getRecordingUrl(this.announcement.recordingId);
    }
    return "No recording exists";
  }

  togglePanel(): void {
    this.editPanel.emit();
  }
}
